import React, { Component } from "react";

export default class StatusIcon extends Component {
  /*constructor(props) {
    super(props);
  }*/

  renderBar(color, filled = false) {
    // console.log(filled);
    let fill = "#0000";
    if (filled) {
      fill = color;
    }
    if (this.props.hasBar) {
      return (
        <div
          style={{
            width: "40px",
            height: "5px",
            borderColor: color,
            border: "1px solid " + color,
            borderLeft: "0px",
            borderRight: "0px",
            backgroundColor: fill
          }}
        ></div>
      );
    } else {
      return null;
    }
  }

  render() {
    let doneStyle = {};
    let backgroundColor = "#FFF3";
    let barColor = "#FFF3";
    let tickVisible = false;
    let borderStyle = {};
    doneStyle = Object.assign(doneStyle, this.props.style);
    if (this.props.status !== undefined) {
      if (this.props.status === "done") {
        // backgroundColor = this.props.doneColor;
        backgroundColor = 'rgb(232, 232, 232)';
        barColor = this.props.doneColor;
        // doneStyle.filter = 'blur(1px) opacity(50%)';
        tickVisible = true;
      } else if (this.props.status === "active") {
        backgroundColor = this.props.activeColor;
      } else if (this.props.status === 'current'){
        backgroundColor = this.props.activeColor;
        borderStyle.border = '7px solid rgb(127, 208, 130)';
      }
    }
    let name = this.props.name;
    let marginLeft = "0px";
    if (this.props.name === "fachlich richtig") {
      marginLeft = "-1.1em";
      name = "   " + name;
    } else if (this.props.name === "sachlich richtig") {
      marginLeft = "-1.1em";
      name = "   " + name;
    } else if (this.props.name === "Rechnung richtig") {
      marginLeft = "-1.8em";
      name = "    " + name;
    } else if (this.props.name === "Anordnung") {
      marginLeft = "-0.5em";
      name = "  " + name;
    } else {
      marginLeft = "-10px";
      name = " " + name;
    }

    return (
      <div
        style={{
          maxWwidth: 200,
          height: 50,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}> */}
        <div>
          <div
            style={{
              width: 55,
              height: 55,
              backgroundColor: backgroundColor,
              borderRadius: 5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 5,
              flexDirection: "row",
              border: borderStyle.border
            }}
          >
            <img src={this.props.src} style={doneStyle} alt="status" />
            {renderTick(tickVisible)}
            </div>
          <p
            style={{
              position: "relative",
              textAlign: "center",
              fontSize: "11px",
              color: "white",
              marginTop: 5,
              marginLeft: marginLeft
            }}
          >
            {name.replace(/ /g, "\u00a0")}
          </p>
        </div>
        <div style={{margin:'0.5em'}}></div>
        {/* {this.renderBar(barColor, this.props.status === "done")} */}
      </div>
    );
  }
}
function renderTick(cond){
  if(cond){
    return <div><div style={{width:'0.5em',height:'1em',background:'green',transform:'rotate(-45deg)',marginLeft:'-1.8em'}}></div><div style={{width:'0.5em',height:'2em',background:'green',transform:'rotate(45deg)',marginTop:'-1.8em',marginLeft:'0.78em',marginLeft:'-1em'}}></div></div>
  }
}


// WEBPACK FOOTER //
// ./src/component/StatusIcon.js